import { useTranslation } from "react-i18next";
import TextField from "@/components/layouts/History/TextField";
import { ContractRenewalType } from "@/pages/contracts/types";
import { getEnumTKey } from "@/utils/strings";

interface Props {
  value: number;
}

const RenewalTypeName: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  return (
    <TextField>
      {t(
        getEnumTKey(
          "contracts.table",
          "renewalTypeValues",
          ContractRenewalType,
          value as ContractRenewalType
        )
      )}
    </TextField>
  );
};

export default RenewalTypeName;
